(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("jquery"), require("maptalks"), require("echarts"), require("axios"), require("js-base64"));
	else if(typeof define === 'function' && define.amd)
		define(["jquery", "maptalks", "echarts", "axios", "js-base64"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("jquery"), require("maptalks"), require("echarts"), require("axios"), require("js-base64")) : factory(root["jquery"], root["maptalks"], root["echarts"], root["axios"], root["js-base64"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_97__, __WEBPACK_EXTERNAL_MODULE_99__, __WEBPACK_EXTERNAL_MODULE_298__, __WEBPACK_EXTERNAL_MODULE_329__, __WEBPACK_EXTERNAL_MODULE_367__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition